import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { loginUser } from "../../../actions/authActions";
import { setModalOpen, closeModal } from "../../../actions/siteActions";
import TextField from "../../FormComponents/TextField";
import {
  Container,
  Grid,
  Form,
} from "semantic-ui-react";
import styles from "./Login.module.scss";
import { Heading2 } from "../../value-cssmodules/TextComponent";
import MainButton from "../../Button/MainButton";
import LightButton from "../../Button/LightButton";
import { Navigate, useNavigate } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { PopupInner } from "../../../types/siteTypes";
import { isAuthenticatedSelector } from "../../../utils/selectors";

const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const dispatch = useDispatch();
  const intl = useIntl();
  const isAuthenticated = useSelector((state) =>
    isAuthenticatedSelector(state)
  );
  const { email, password } = formData;
  const navigate = useNavigate();

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    dispatch(loginUser(email, password));
  };

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className={styles.self}>
      <Container>
        <Grid centered>
          <Grid.Column mobile={8} computer={12}>
            <Heading2 className={styles.centered}>
              <FormattedMessage id="site.login" defaultMessage="Login" />
            </Heading2>
            <Form onSubmit={onSubmit}>
              <Form.Field>
                <TextField
                  // error={errors.email}
                  name="email"
                  placeholder={intl.formatMessage({
                    id: "login.placeholder.email",
                    defaultMessage: "Login/e-mail",
                  })}
                  onChange={onChange}
                  type="email"
                  value={email}
                />
                <TextField
                  // error={errors.password}
                  name="password"
                  placeholder={intl.formatMessage({
                    id: "login.placeholder.password",
                    defaultMessage: "Password",
                  })}
                  onChange={onChange}
                  type="password"
                  value={password}
                />
                <div className={styles.centered}>
                  <MainButton className={styles.loginMainButton}>
                    <FormattedMessage
                      id={"site.login"}
                      defaultMessage={"Login"}
                    />
                  </MainButton>
                </div>
                <div className={styles.redirects}>
                  <div
                    className={styles.links}
                    onClick={() =>
                      dispatch(setModalOpen(PopupInner.ForgottenPassword))
                    }
                  >
                    <FormattedMessage
                      id={"site.forgottenPassword"}
                      defaultMessage={"Forgotten Password"}
                    />
                  </div>
                  <div
                    className={styles.links}
                    onClick={() => dispatch(setModalOpen(PopupInner.Register))}
                  >
                    <FormattedMessage
                      id={"site.noAccount"}
                      defaultMessage={"Create your account"}
                    />
                  </div>
                </div>
                <div className={styles.centered}>
                  <LightButton className={styles.loginLightButtonMenu}
                    type="button"
                    onClick={() => {
                      dispatch(closeModal());
                      navigate("/register");
                    }}
                  >
                    <FormattedMessage id="register.button.submit" defaultMessage="Register" />
                  </LightButton>
                </div>
              </Form.Field>
            </Form>
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
};

export default Login;
